<ng-container *transloco="let t">
  <div class="experience-editor-view" role="region" [attr.aria-label]="t('experience.editorViewTags')">
    <section [ngClass]="{empty: tags().length === 0, columns: tags().length > 2}" class="tags">
      @for (tag of tags(); track tag) {
        <div class="tag" data-cy="experience-editor-view-tag">
          <h2 class="heading-s" data-cy="experience-editor-view-tag-title">{{ t(tag.titleKey) }}</h2>
          <p class="small" data-cy="experience-editor-view-tag-content">{{ tag.content }}</p>
        </div>
      }
    </section>
    @if (description() || editorialContent().length) {
      <section class="contents">
        <div class="content">
          <h3 class="heading-s" data-cy="experience-editor-view-title"
            ><strong>{{
              experienceStyle() === ExperienceStyle.INSIDERS
                ? t('experience.theInsider')
                : t('experience.theEditorView')
            }}</strong>
          </h3>
          <p class="innerHtml" [innerHTML]="description()" data-cy="experience-editor-view-content"></p>
        </div>
        @for (content of editorialContent(); track content) {
          <div class="content">
            <h3 class="heading-s" data-cy="experience-editor-view-title">{{ content.title }}</h3>
            <p class="innerHtml" [innerHTML]="content.content" data-cy="experience-editor-view-content"></p>
          </div>
        }
        @if (benefits()) {
          <ess-benefits-box [content]="benefits()" />
        }
      </section>
    }
  </div>
</ng-container>
